import { render, staticRenderFns } from "./CustomPreventions.vue?vue&type=template&id=b19da2f4&"
import script from "./CustomPreventions.vue?vue&type=script&lang=js&"
export * from "./CustomPreventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports